import React from "react";

function FileUpload({ onFileUpload }) {
  return (
    <div className="file-upload">
      <h2>Upload PNG Files</h2>
      {/* Hidden input */}
      <input
        type="file"
        accept=".png"
        multiple
        onChange={onFileUpload}
        className="file-input"
        id="file-upload-input"
      />
      {/* Styled label */}
      <label htmlFor="file-upload-input">Choose Files</label>
      <div
  style={{
    display: 'inline-block',
    padding: '10px 20px',
    backgroundColor: '#3F51B5',
    color: 'rgb(255, 255, 255)',
    borderRadius: '5px',
    textDecoration: 'none',
    fontWeight: 'bold',
    marginTop: '20px'
  }}
>
  ❤️ Donations are absolutely necessary to maintain and improve this and other tools. Support us to keep things running smoothly!
  <br />
  <a
    href="https://www.paypal.com/donate/?hosted_button_id=GP3CML2Y9S2ZW"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: 'inline-block',
      padding: '10px 20px',
      backgroundColor: 'rgb(255, 255, 255)',
      color: 'rgb(0, 0, 0)',
      borderRadius: '5px',
      textDecoration: 'none',
      fontWeight: 'bold',
      marginTop: '10px'
    }}
  >
    Donate via PayPal (Credit & Debit supported)
  </a>
</div>
    </div>
  );
}

export default FileUpload;
